<template>
	<v-card flat outlined class="pb-0 pt-0">
		<v-card-text class="pb-0 pt-0">
			<v-row class="pl-0 pt-2">
				<CandidateIssuedCertificates></CandidateIssuedCertificates>
			</v-row>
			<v-row class="pb-0 pt-2">
				<CandidateBrevets></CandidateBrevets>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import CandidateIssuedCertificates from './CandidateIssuedCertificates';
import CandidateBrevets from './CandidateBrevets';

export default {
	name: 'CandidateCertificates',
	components: { CandidateIssuedCertificates, CandidateBrevets },
	data() {
		return {};
	},
};
</script>

<style scoped></style>
